import { render, staticRenderFns } from "./AUHeader.vue?vue&type=template&id=53ffd816&"
import script from "./AUHeader.vue?vue&type=script&lang=js&"
export * from "./AUHeader.vue?vue&type=script&lang=js&"
import style0 from "./AUHeader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports